import { Link } from "react-router-dom";
import { useCart } from "@/context/CartContext";
import { Seo } from "@/components/seo/Seo";
import { SEO } from "@/data/seo";

export default function PaymentCancel() {
  const { setOpen, count } = useCart();
  return (
    <div className="flex min-h-screen items-center bg-ivory pb-24 pt-40" data-testid="payment-cancel-page">
      <Seo {...SEO.private} />
      <div className="container-pf max-w-3xl text-center">
        <p className="eyebrow">Pagamento annullato</p>
        <h1 className="mt-6 font-display text-4xl font-medium leading-tight text-navy sm:text-6xl">Nessun problema, il tuo carrello ti aspetta.</h1>
        <p className="mx-auto mt-6 max-w-xl text-lg text-slate2">Non è stato addebitato alcun importo. Puoi riprendere l'acquisto quando preferisci.</p>
        <div className="mt-12 flex flex-col justify-center gap-4 sm:flex-row">
          {count > 0 && (
            <button type="button" onClick={() => setOpen(true)} className="btn-primary" data-testid="cancel-open-cart">
              Riapri il carrello
            </button>
          )}
          <Link to="/collezione" className="btn-ghost" data-testid="cancel-back-to-shop">
            Torna alla collezione
          </Link>
        </div>
      </div>
    </div>
  );
}
